import { configureStore } from "@reduxjs/toolkit";
import navReducer from "../redux/navReducer";
import notificationReducer from "../redux/notificationReducer";
import clientReducer from "../redux/clientReducer";

const store = configureStore({
  reducer: {
    navbar: navReducer,
    notification: notificationReducer,
    client: clientReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export const dispatch = store.dispatch;
export default store;
